// Custom plan trigger values
export const CUSTOM_PLAN_TRIGGERS = {
  SOCIAL_ACCOUNTS: 251,
  USERS: 201,
  SOURCES: 251,
}

// Helper function to check if custom plan is needed
export function needsCustomPlan(state) {
  return (
    state.socialAccounts === CUSTOM_PLAN_TRIGGERS.SOCIAL_ACCOUNTS ||
    state.users === CUSTOM_PLAN_TRIGGERS.USERS ||
    state.sources === CUSTOM_PLAN_TRIGGERS.SOURCES
  )
}
